import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const FILL = color.surface.cta;

const body: _SVGIcon.IconBody = (params) => {
	const fill = params?.fill ?? FILL;
	return `
   <path fill-rule="evenodd" clip-rule="evenodd" d="M9.59496 8.00772L4.30207 2.706L5.71746 1.29297L11.7175 7.30297C11.9049 7.49076 12.0101 7.74538 12.0098 8.01074C12.0094 8.2761 11.9036 8.53045 11.7157 8.71777L5.70568 14.7078L4.29383 13.2912L9.59496 8.00772Z" fill="${fill}"/>
  `;
};

export default {
	W: 16,
	H: 16,
	body,
} as _SVGIcon.Icon;
